<template>
	<v-row class="fill-height" justify="center" align="start">
		<v-col cols="12">
			<div class="d-flex justify-space-between py-5">
				<div class="d-flex cursor-pointer" @click="$router.go(-1)">
					<v-icon>mdi-chevron-left</v-icon>
					<div class="ml-2">Back</div>
				</div>
				<div>
					<span>New to Homify?</span>
					<span
						class="text-decoration-underline secondary--text ml-2 cursor-pointer"
						@click="goToPage('auth.register')"
						>Sign Up</span
					>
				</div>
			</div>
		</v-col>
		<v-col cols="11" md="8">
			<div>
				<p class="text-h4 font-weight-bold">
					Change Password for your
					<span class="secondary--text text-h4 font-weight-bold homify-title"
						>Homify</span
					>
					Account
				</p>
				<p class="mb-6">Enter your new password.</p>
				<v-divider />

				<div class="mb-2 mt-10">Password*</div>
				<v-text-field
					@click:append="isPasswordVisible = !isPasswordVisible"
					:append-icon="isPasswordVisible ? 'mdi-eye-off' : 'mdi-eye'"
					:rules="[rules.required]"
					:type="isPasswordVisible ? 'text' : 'password'"
					v-model="form.password"
					placeholder="Enter password"
					outlined
				></v-text-field>

				<div class="mb-2">Confirm Password*</div>
				<v-text-field
					@click:append="isChangePasswordVisible = !isChangePasswordVisible"
					:append-icon="isChangePasswordVisible ? 'mdi-eye-off' : 'mdi-eye'"
					:rules="[rules.required, rules.matchPassword]"
					:type="isChangePasswordVisible ? 'text' : 'password'"
					v-model="form.confirmPassword"
					placeholder="Enter password"
					outlined
				></v-text-field>

				<v-btn
					block
					:loading="isLoading"
					depressed
					color="primary"
					:disabled="isDisabled"
					class="py-7 mt-10 text-none"
					@click="changePassword"
					>Submit</v-btn
				>
			</div>
		</v-col>
	</v-row>
</template>

<script>
	import { mapActions, mapState } from "vuex";
	import { AuthService } from "@/services/index.js";

	export default {
		data() {
			return {
				rememberMeCheckbox: false,
				isLoading: false,
				isLinkSent: false,
				isPasswordVisible: false,
				isChangePasswordVisible: false,
				form: {
					email: "",
					password: "",
					confirmPassword: "",
				},
				rules: {
					required: (value) => !!value || "Required.",
					counter: (value) => value.length <= 20 || "Max 20 characters",
					minCounter: (value) => value.length > 6 || "Min 6 characters",
					email: (value) => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(value) || "Invalid e-mail.";
					},
					matchPassword: (value) => {
						return value == this.form.password || "Passwords do not match";
					},
				},
			};
		},
		computed: {
			...mapState(["userObj"]),
			isDisabled() {
				return (
					this.form.password.length == 0 ||
					this.form.password != this.form.confirmPassword
				);
			},
		},
		methods: {
			...mapActions("auth", ["forgotPassword"]),
			goToPage(name) {
				this.$router.push({ name });
			},
			async changePassword() {
				try {
					this.isLoading = true;
					if (this.form.password == this.form.confirmPassword) {
						let token = this.$route.params.token;

						const { message } = await AuthService.resetPassword({
							newpassword: this.form.password,
							newpasswordconfirm: this.form.password,
							token: token,
						});

						this.$store.commit("openSnackbar", message);
					} else {
						this.$store.commit("openSnackbar", "Your passwords must match");
					}

					this.isLoading = false;
				} catch (error) {
					this.isLoading = false;
					//  throw error;
				}
			},
		},
	};
</script>
